import { SET_SEARCH } from "../../utils/constantes";

const setSearch = (payload) => {
    return{
        type: SET_SEARCH,
        payload
    }
};

export default setSearch;